import { render, staticRenderFns } from "./BalaPFList.vue?vue&type=template&id=16a9daf0&scoped=true"
import script from "./BalaPFList.vue?vue&type=script&lang=js"
export * from "./BalaPFList.vue?vue&type=script&lang=js"
import style0 from "./BalaPFList.vue?vue&type=style&index=0&id=16a9daf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9daf0",
  null
  
)

export default component.exports